var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6549 6.58203C11.4243 6.58203 11.2374 6.76897 11.2374 6.99956V11.2366H2.76316V6.99956C2.76316 6.76897 2.57627 6.58203 2.34563 6.58203C2.11499 6.58203 1.9281 6.76897 1.9281 6.99956V11.6541C1.9281 11.8847 2.11499 12.0717 2.34563 12.0717H11.6549C11.8856 12.0717 12.0725 11.8847 12.0725 11.6541V6.99956C12.0725 6.76897 11.8855 6.58203 11.6549 6.58203Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8777 6.70437L7.29481 0.122273C7.1318 -0.0407857 6.86742 -0.04073 6.70436 0.122273L0.12231 6.70437C-0.0407496 6.86743 -0.0407496 7.13181 0.12231 7.29482C0.203867 7.37632 0.310755 7.41712 0.417587 7.41712C0.524475 7.41712 0.631307 7.37637 0.712864 7.29482L6.9997 1.00794L13.2873 7.29482C13.4503 7.45788 13.7147 7.45782 13.8778 7.29476C14.0408 7.13176 14.0408 6.86738 13.8777 6.70437Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDashboard);
export default __webpack_public_path__ + "static/media/my-dashboard.192371a1.svg";
export { ForwardRef as ReactComponent };